import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appNextFieldId]',
  standalone: false, // NOSONAR: usado desde SharedModule; migración a standalone en otro cambio
})

export class NextFieldIdDirective {
  @Input('appNextFieldId') nextInputId: string;

  constructor() { }

  private applyFocus(nextInputElement: HTMLElement, selectpickerRetry = 0): void {
    const tagName = nextInputElement.tagName.toLowerCase();
    if (tagName === 'input' || tagName === 'textarea') {
      nextInputElement.focus();
    } else if (tagName === 'select') {
      const selectEl = nextInputElement as HTMLSelectElement;
      const wrapper = selectEl.closest?.('.bootstrap-select') ?? selectEl.nextElementSibling;
      const toggle = wrapper?.querySelector?.('.dropdown-toggle');
      if (toggle instanceof HTMLElement) {
        toggle.focus();
        toggle.click();
      } else if (selectEl.classList?.contains('selectpicker') && selectpickerRetry < 2) {
        const delay = selectpickerRetry === 0 ? 100 : 250;
        setTimeout(() => this.applyFocus(nextInputElement, selectpickerRetry + 1), delay);
      } else {
        selectEl.focus();
      }
    } else {
      const event = new Event('openNgSelect', { bubbles: true, cancelable: true });
      nextInputElement.dispatchEvent(event);
    }
  }

  private focusNext(retryCount = 0): void {
    if (!this.nextInputId) return;
    const nextInputElement = document.getElementById(this.nextInputId);
    if (nextInputElement) {
      this.applyFocus(nextInputElement);
      return;
    }
    const maxRetries = 4;
    const delays = [50, 100, 200, 350];
    if (retryCount < maxRetries) {
      const delay = delays[retryCount];
      setTimeout(() => this.focusNext(retryCount + 1), delay);
    }
  }

  @HostListener('change') onChange(): void {
    setTimeout(() => this.focusNext(), 0);
  }

  @HostListener('keydown.enter', ['$event']) onEnter(event: KeyboardEvent): void {
    const target = event.target as HTMLElement;
    if (target?.tagName === 'SELECT') return;
    event.preventDefault();
    setTimeout(() => this.focusNext(), 10);
  }
}
